import type { WebSocketResponse, WebSocketBaseData } from '~/modules/apps/contexts/type';
import type { IClickMapPoint, IClickedElement, IHeatmapAnalytics } from './index';

// Websocket message types - these should match the backend event names
export enum HeatmapWSMessageType {
  CLICKS = 'heatmapClicks',
  CLICKED_ELEMENTS = 'clickedElements',
  ANALYTICS = 'heatmapAnalytics',
}

// Websocket data types
export type WSHeatmapClicksData = WebSocketBaseData<IClickMapPoint[]>;
export type WSHeatmapClickedElementsData = WebSocketBaseData<IClickedElement[]>;
export type WSHeatmapAnalyticsData = WebSocketBaseData<IHeatmapAnalytics>;

// Websocket response types
export type WSHeatmapClicksResponse = WebSocketResponse<WSHeatmapClicksData>;
export type WSHeatmapClickedElementsResponse = WebSocketResponse<WSHeatmapClickedElementsData>;
export type WSHeatmapAnalyticsResponse = WebSocketResponse<WSHeatmapAnalyticsData>;
